import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import DonationsCard from '@client/containers/donationsCard/DonationsCard';
import Image from '@client/components/image/Image';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { reverseRoutes } from '@client/pages/reverseRoutes';
import {
  fakeEllipsis,
  getImageOrDefault,
  valueOrEmptyStr,
} from '@client/shared/utils/utils/utils';
import Markdown from '@client/components/markdown/Markdown';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import SocialMediaSharing from '@client/components/socialMediaSharing/SocialMediaSharing';
import ReactLink from '@client/components/reactLink/ReactLink';
import FundraiserCardTargetsBox from '@client/containers/fundraiserCardTargetsBox/FundraiserCardTargetsBox';
import { selectUserInfo } from '@client/redux/user/userReducer';
import { hideSwishCardByfundraiserId } from '@client/helpers/hideSwishCardByFundraiserId';
import Guestbook from '@client/containers/guestbook/Guestbook';
import {
  getSocialMediaBoxText,
  isMemorialFundraiser,
  remapFundraiserTypeName,
} from '@client/shared/utils/fundraiserUtils/fundraiserUtils';
import { SwishCard } from '@client/containers/swishCard/SwishCard';
import styles from './individualFundraiser.scss';

class IndividualFundraiser extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isShowingGuestbook: false,
    };

    this.handleToggleGuestbook = this.handleToggleGuestbook.bind(this);
  }

  handleToggleGuestbook() {
    this.setState((state) => {
      return { ...state, isShowingGuestbook: !this.state.isShowingGuestbook };
    });
  }

  getMemorialInformation = (fundraiser) => {
    const memorialFirstName = getIn(fundraiser, 'memorialFirstName') || '';
    const memorialLastName = getIn(fundraiser, 'memorialLastName') || '';
    const memorialBirthDate = getIn(fundraiser, 'memorialBirthDate') || '';
    const memorialDeathDate = getIn(fundraiser, 'memorialDeathDate') || '';
    return `${memorialFirstName} ${memorialLastName} (${memorialBirthDate.substring(
      0,
      10
    )} - ${memorialDeathDate.substring(0, 10)})`;
  };

  render() {
    const {
      className,
      fundraiser,
      sharedUrl,
      disableClick,
      translations,
      donations,
      user,
    } = this.props;

    const creator = getIn(fundraiser, 'creator');
    const creatorId = getIn(creator, 'userId');
    const guestbookData = getIn(translations, 'guestbookData', 'fields');

    const fundraiserDescription =
      getIn(fundraiser, 'description') ||
      getIn(translations, 'defaultDescriptionText');

    const isMemorial = isMemorialFundraiser(
      getIn(fundraiser, 'fundraiserType')
    );

    const socialMediaBoxText = getSocialMediaBoxText(translations, fundraiser);

    const memorialInformation =
      isMemorial && this.getMemorialInformation(fundraiser);

    const titleFundraiserDescription = isMemorial
      ? getIn(translations, 'titleMemorialFundDescription')
      : getIn(translations, 'titleFundraiserDescription');

    const isMyFundraiser = creatorId && creatorId === getIn(user, 'sub');

    const isLongTitle =
      getIn(fundraiser, 'title') && getIn(fundraiser, 'title').length > 55;

    const fundraiserId = getIn(fundraiser, 'id');
    const hideSwishCard = hideSwishCardByfundraiserId(fundraiserId);

    const name = getIn(fundraiser, 'creator', 'firstName');

    return (
      <div
        className={`${styles.individualFundraiser}${
          className ? ` ${className}` : ''
        }`}
      >
        <span className={styles.fundraiserTypeLabel}>
          {remapFundraiserTypeName(getIn(fundraiser, 'fundraiserType'))}
        </span>
        {disableClick && <div className={styles.overlay} />}
        <div className={styles.ifImageContainer}>
          {!disableClick && isMyFundraiser && (
            <div className={styles.editButtonContainer}>
              <ReactLink
                className={styleHelper.btnPrimaryMd}
                to={`/insamling/${getIn(fundraiser, 'id')}?edit=true`}
              >
                Redigera
              </ReactLink>
            </div>
          )}
          <div className={styles.centerContainer}>
            <h1
              className={`${styleHelper.titleLgPrimary} ${
                styles.fundraiserTitle
              } ${isLongTitle ? styles.smallTitle : ''}`}
            >
              {/* using fakeEllipsis to crop already posted fundraisers with to long titles that was posted before a limit was set */}
              {fakeEllipsis(getIn(fundraiser, 'title'), 120)}
            </h1>
            <p>Skapad av {name}</p>
            <ReactLink
              className={`${styleHelper.btnPrimaryMd} ${styles.donateButton}`}
              to={reverseRoutes.donate({ fundraiserId: fundraiser.get('id') })}
            >
              Bidra till insamlingen
            </ReactLink>
          </div>
          <Image
            className={styles.ifImage}
            src={getImageOrDefault(getIn(fundraiser, 'imageUrl'))}
          />
        </div>

        <div className={`${styles.ifContent}`}>
          <div
            className={`${styles.ifInformation} ${styleHelper.layoutMobileAndTabletSidePadding}`}
          >
            {isMemorial && (
              <>
                <h2 className={styleHelper.titleMdPrimary}>
                  {memorialInformation}
                </h2>
                <hr className={styles.hr} />
              </>
            )}
            <div className={`${styles.targetsBox}`}>
              <FundraiserCardTargetsBox
                amountDonated={getIn(fundraiser, 'amountDonated')}
                fullWidthProgressBar={true}
                largeFont={true}
                targetAmount={getIn(fundraiser, 'targetAmount')}
                showDonatedSoFarLabel={true}
              />
            </div>
            <div
              className={`${styleHelper.flexRow} ${styles.ifInformationTabs}`}
            >
              <h4 className={styleHelper.titleSmPrimary}>
                {this.state.isShowingGuestbook
                  ? getIn(guestbookData, 'viewGuestbookButton')
                  : titleFundraiserDescription}
              </h4>
              <button
                className={classNames(styleHelper.btnFlat)}
                onClick={this.handleToggleGuestbook}
              >
                <h4 className={styleHelper.btnFlat}>
                  {this.state.isShowingGuestbook
                    ? titleFundraiserDescription
                    : getIn(guestbookData, 'viewGuestbookButton')}
                </h4>
              </button>
            </div>
            {this.state.isShowingGuestbook ? (
              <Guestbook
                isMyFundraiser={isMyFundraiser}
                fundraiserSlug={getIn(fundraiser, 'slug')}
                fundraiserId={getIn(fundraiser, 'id')}
                onToggleGuestbook={this.handleToggleGuestbook}
                translations={guestbookData}
              />
            ) : (
              <>
                <Markdown
                  className={`${styles.markdownProp}`}
                  value={valueOrEmptyStr(fundraiserDescription)}
                  viewAsTextarea={false}
                  disallowedTypes={['link']}
                />
              </>
            )}
          </div>
          <div className={styles.boxContainer}>
            {!hideSwishCard && (
              <div className={`${styles.sharingBox} ${styles.swish}`}>
                <SwishCard
                  title={getIn(translations, 'swishBoxTitle')}
                  text={getIn(translations, 'swishBoxText')}
                  swishId={getIn(fundraiser, 'neiGuidCode')}
                />
              </div>
            )}
            <div className={styles.sharingBox}>
              <DonationsCard fundraiser={fundraiser} donations={donations} />
            </div>
            <div className={`${styles.sharingBox} ${styles.share}`}>
              <h3>Dela insamlingen</h3>
              <p>{socialMediaBoxText}</p>
              <SocialMediaSharing
                fundraiserId={getIn(fundraiser, 'id')}
                url={sharedUrl || ''}
                hashtag="hjärtlungfonden"
                via="hjartlungfonden"
                title={getIn(fundraiser, 'title')}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

IndividualFundraiser.propTypes = {
  className: PropTypes.string,
  sharedUrl: PropTypes.string,
  location: PropTypes.object,
  disableClick: PropTypes.bool,
  translations: ImmutablePropTypes.map,
  user: ImmutablePropTypes.mapContains({
    sub: PropTypes.string,
  }),
  fundraiser: ImmutablePropTypes.mapContains({
    id: PropTypes.string,
    slug: PropTypes.string,
    neiGuidCode: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    targetAmount: PropTypes.number,
    amountDonated: PropTypes.number,
    imageUrl: PropTypes.string,
    creator: ImmutablePropTypes.mapContains({
      firstName: PropTypes.string,
      userId: PropTypes.string, //google auth'ed
    }),
  }),
  donations: ImmutablePropTypes.list,
};

function mapStateToProps(state) {
  return {
    user: selectUserInfo(state),
  };
}

export default connect(mapStateToProps)(IndividualFundraiser);
